import { IconDefinition } from '@ant-design/icons-angular';

export const PlaySquareOutline: IconDefinition = {
    name: 'play-square',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z" /><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" /></svg>'
}